import type { AxiosResponse } from 'axios'
import { BaseApiService } from './base.service'

export interface Ambassador {
  id: number
  ambassador_name: string
  ambassador_email: string
  fz_ambassador_id: number
}

export class AmbassadorService extends BaseApiService<Ambassador> {
  constructor() {
    super('/ambassadors')
  }

  async search(query: string, limit = 20): Promise<AxiosResponse<Ambassador[]>> {
    return this.client.get(this.collectionUrl, { params: { search: query, limit } })
  }
}

export const ambassadorService = new AmbassadorService()
